export function appControlSliderInit() {
  const appControlArrows = document.querySelectorAll(
    '[data-app-control-slider-arrow]'
  );
  const appControlSlides = document.querySelectorAll(
    '[data-app-control-slider-slide]'
  );

  appControlArrows.forEach((appControlArrow, arrowIndex) => {
    appControlArrow.addEventListener('click', () => {
      const newActiveSlideIndex = findPrevAndNextIndexes()[arrowIndex];

      appControlSlides.forEach((appControlSlide) => {
        appControlSlide.removeAttribute('data-active');
      });

      appControlSlides[newActiveSlideIndex].setAttribute('data-active', 'true');
    });
  });

  function findPrevAndNextIndexes() {
    return Array.from(appControlSlides).reduce(
      (acc, appControlSlide, slideIndex) => {
        const firstSlideIndex = 0;
        const lastSlideIndex = appControlSlides.length - 1;

        if (appControlSlide.hasAttribute('data-active')) {
          const nextSlideIndex = slideIndex + 1;
          const prevSlideIndex = slideIndex - 1;

          if (slideIndex === firstSlideIndex) {
            acc.splice(0, 2, lastSlideIndex, nextSlideIndex);
          } else if (slideIndex === lastSlideIndex) {
            acc.splice(0, 2, prevSlideIndex, firstSlideIndex);
          } else {
            acc.splice(0, 2, prevSlideIndex, nextSlideIndex);
          }
        }

        return acc;
      },
      []
    );
  }
}
